import { render, staticRenderFns } from "./DiskMonitoring.vue?vue&type=template&id=cc0cebb6&scoped=true"
import script from "./DiskMonitoring.vue?vue&type=script&lang=js"
export * from "./DiskMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0cebb6",
  null
  
)

export default component.exports